<template>
    <div class="country-bn" :class="$x.nsAddressForm">
        <VTextField
            v-model="address.address1"
            name="address1"
            maxlength="40"
            required
            validate-on-blur
            :label="t.address1Label"
            class="flex-column"
            :rules="address1Rules"
            @blur="onBlur"
            @input="addressUpdated"
        ></VTextField>
        <VTextField
            v-model="address.address2"
            name="address2"
            maxlength="35"
            validate-on-blur
            class="flex-column"
            :aria-label="t.address2Label"
            :rules="address2Rules"
            @blur="onBlur"
            @input="addressUpdated"
        >
            <template #label>
                {{ t.address2Label }}
                <span :class="$x.optional"> {{ t.optional }} </span>
            </template>
        </VTextField>
        <div :class="$x.flexContainer">
            <VTextField
                v-model="address.postalCode"
                name="postalCode"
                maxlength="6"
                required
                validate-on-blur
                :label="t.postalCodeLabel"
                :class="$x.firstCol"
                class="flex-column"
                :rules="postalCodeRules"
                @blur="onBlur"
                @input="postCodeChanged"
            ></VTextField>
            <VTextField
                ref="addressCity"
                v-model="address.city"
                name="city"
                maxlength="25"
                required
                validate-on-blur
                :label="t.cityLabel"
                :class="$x.firstCol"
                class="flex-column"
                :rules="cityRules"
                :readonly="postCodeLookedUp"
                @blur="onBlur"
                @input="addressUpdated"
            ></VTextField>
            <VTextField
                ref="addressRegion"
                v-model="address.region"
                name="region"
                maxlength="2"
                required
                validate-on-blur
                :label="t.regionLabel"
                class="flex-column"
                :class="$x.region"
                :readonly="postCodeLookedUp"
                :rules="cityRules"
                @blur="onBlur"
                @input="addressUpdated"
            ></VTextField>
        </div>
    </div>
</template>

<script>
import { VTextField } from 'vuetify/lib';
import ADDRESS_MIXIN from '../addressMixin';
import POST_CODE_LOOKUP from '../postalCodeLookup';
// Most of the logic for this component is in the mixin
import TRANSLATIONS from './translations';

export default {
    name: 'NsAddressBn',
    components: {
        VTextField,
    },
    mixins: [ADDRESS_MIXIN, POST_CODE_LOOKUP],
    data() {
        return {
            postCodeLength: 6,
        };
    },
    mounted() {
        this.address.country = 'BN';
        this.postalCodeResetRefs = [
            this.$refs.addressCity,
            this.$refs.addressRegion,
        ];

        if (TRANSLATIONS[this.lang]) {
            this.t = TRANSLATIONS[this.lang];
        } else {
            // If the language isn't available then get the first language in translations file
            this.t = TRANSLATIONS[Object.keys(TRANSLATIONS)[0]];
        }
        this.$emit('new-address-in-form');
    },
    methods: {},
};
</script>

<style lang="scss" module="$x">
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";

$color-eeyore: map.get(colors.$baseColors, eyore);

::v-deep *:not(.v-icon) {
  font-family: map.get(typographyVariables.$typography, font-family-primary);
}

.nsAddressForm {
  .flexContainer {
    display: flex;
    align-content: space-between;
    .firstCol {
      margin-right: 20px;
    }
    .region {
      width: 70px;
    }
  }
}

.optional {
  color: $color-eeyore;
}
</style>
